(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /**
   * アカウントリンク（#HeaderAccountLink）の cartCount クエリを更新する。
   * カート数量変更（cartUpdate）や page.cart-count-js から呼ばれる。
   * @param {number|string} count
   */
  window.__rcSetCartCount = function (count) {
    const link = document.getElementById('HeaderAccountLink');
    if (!link) return;

    const nextCount = Math.max(0, Number(count) || 0);
    try {
      const url = new URL(link.href);
      url.searchParams.set('cartCount', String(nextCount));
      link.href = url.toString();
    } catch (err) {
      link.href = link.href.replace(/([?&]cartCount=)\d*/, `$1${nextCount}`);
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const itemCount = event?.cartData?.item_count;
      if (itemCount === undefined || itemCount === null) return;
      window.__rcSetCartCount(itemCount);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const isVisible = (el) => !!(el && (el.offsetParent !== null || el.getClientRects().length));

    const focusSel = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    const openerMap = new WeakMap(); // modal -> opener
    const trapMap = new WeakMap(); // modal -> trap handler
    const placementMap = new WeakMap(); // modal -> { parent, next }

    function moveModalToBody(modal) {
      if (!modal) return;
      if (!placementMap.has(modal)) {
        placementMap.set(modal, { parent: modal.parentNode, next: modal.nextSibling });
      }
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    }

    function restoreModalPlacement(modal) {
      const placement = placementMap.get(modal);
      if (!placement || !placement.parent) return;
      if (!document.contains(placement.parent)) return;
      if (placement.next && placement.parent.contains(placement.next)) {
        placement.parent.insertBefore(modal, placement.next);
      } else {
        placement.parent.appendChild(modal);
      }
    }

    function openModal(modal, opener) {
      if (!modal) return;
      moveModalToBody(modal);
      openerMap.set(modal, opener || null);

      modal.hidden = false;
      document.body.classList.add('modal-open');

      const first = modal.querySelector(focusSel);
      (first || modal).focus({ preventScroll: true });

      const trap = (e) => {
        if (e.key !== 'Tab') return;
        const list = Array.from(modal.querySelectorAll(focusSel)).filter(isVisible);
        if (!list.length) return;
        const first = list[0];
        const last = list[list.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };
      modal.addEventListener('keydown', trap);
      trapMap.set(modal, trap);

      document.addEventListener('keydown', onEscape);
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove('modal-open');

      const trap = trapMap.get(modal);
      if (trap) modal.removeEventListener('keydown', trap);
      document.removeEventListener('keydown', onEscape);

      const opener = openerMap.get(modal);
      if (opener && document.contains(opener)) {
        opener.focus({ preventScroll: true });
      }

      restoreModalPlacement(modal);
    }

    function onEscape(e) {
      if (e.key !== 'Escape') return;
      const opened = document.querySelector('.attention-modal:not([hidden])');
      if (opened) closeModal(opened);
    }

    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('.search--attention');
      if (openBtn) {
        e.preventDefault();

        const root = openBtn.closest('[id^="shopify-section"]') || document;

        const modal = root.querySelector('.attention-modal');
        openModal(modal, openBtn);
        return;
      }

      const closeEl = e.target.closest('[data-close-modal]');
      if (closeEl) {
        e.preventDefault();
        const modal = closeEl.closest('.attention-modal');
        closeModal(modal);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
